import * as React from 'react'
import { NextPage } from 'next'
import { PageProps } from '@/types'

import Meta from '@/components/Meta'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

type LayoutProps = Pick<PageProps, 'headerHTML' | 'footerHTML'> & {
  children: React.ReactNode
}

const Layout: NextPage<LayoutProps> = ({
  headerHTML,
  footerHTML,
  children
}) => (
  <>
    <Meta />
    <Header headerHTML={headerHTML} />
    {children}
    <Footer footerHTML={footerHTML} />
  </>
)

export default Layout
